define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getCookie = void 0;

  var getCookie = function getCookie(name) {
    var cookies = document.cookie.split(';');
    var cookie = cookies.filter(function (item) {
      return item.includes(name);
    }).pop();

    if (cookie) {
      var value = cookie.split('=').pop();
      return value;
    }
  };

  _exports.getCookie = getCookie;
});